// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"2c0fe8b9","453":"01094a83"}[chunkId] + ".chunk.css";
};